var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGstSubscriptionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 138689"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 10",
    cx: 16,
    cy: 16.0002,
    r: 16,
    fill: "#F8E9E5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.5598 8.00024H12.6744C9.73178 8.00024 9 8.78367 9 11.9096V20.6437C9 22.707 10.1366 23.1957 11.5145 21.7219L11.5223 21.7141C12.1606 21.0393 13.1338 21.0936 13.6865 21.8305L14.4728 22.8776C15.1034 23.7076 16.1232 23.7076 16.7538 22.8776L17.54 21.8305C18.1005 21.0858 19.0736 21.0315 19.712 21.7141C21.0977 23.1879 22.2265 22.6992 22.2265 20.636V11.9096C22.2343 8.78367 21.5025 8.00024 18.5598 8.00024ZM13.2817 11.8786C13.7098 11.8786 14.0602 12.2277 14.0602 12.6543C14.0602 13.0809 13.7176 13.43 13.2817 13.43C12.8457 13.43 12.5032 13.0809 12.5032 12.6543C12.5032 12.2277 12.8457 11.8786 13.2817 11.8786ZM17.9526 17.3083C17.5167 17.3083 17.1741 16.9593 17.1741 16.5326C17.1741 16.106 17.5245 15.757 17.9526 15.757C18.3808 15.757 18.7311 16.106 18.7311 16.5326C18.7311 16.9593 18.3886 17.3083 17.9526 17.3083ZM18.6533 12.3363L13.414 17.5565C13.2972 17.6729 13.1493 17.7272 13.0014 17.7272C12.8535 17.7272 12.7056 17.6729 12.5888 17.5565C12.3631 17.3316 12.3631 16.9593 12.5888 16.7343L17.8281 11.514C18.0538 11.2891 18.4275 11.2891 18.6533 11.514C18.879 11.739 18.879 12.1113 18.6533 12.3363Z",
    fill: "#C73E1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGstSubscriptionIcon);
export default __webpack_public_path__ + "static/media/gstSubscriptionIcon.e3e9cfad928cd49ac4240692c91611cb.svg";
export { ForwardRef as ReactComponent };